const files = require.context('@/views', true, /\.vue$/)
const routes = []

files.keys().forEach(key => {
  // 过滤掉组件名称为空的文件（如布局组件）
  if (key.includes('components/')) return

  // 转换路径为路由格式，注意目录下默认有index有，路径忽略掉
  let pattern = /\/index.vue$/
  if (pattern.test(key)) {
    const path = key
      .replace(/^\.\//, '')         // 去除开头的./
      .replace(/\.vue$/, '')        // 去除.vue后缀    
      .toLowerCase()               // 转为小写

    routes.push({
      path: `/${path}`,
      name: path.replace(/\//g, '-'),
      component: () => import(`@/views/${key.replace(/^\.\//, '')}`)
    })
  }
  const path = key
    .replace(/^\.\//, '')         // 去除开头的./
    .replace(/\.vue$/, '')        // 去除.vue后缀
    .replace(/\/index$/, '')      // 去除index
    .toLowerCase()               // 转为小写
  
  routes.push({
    path: `/${path}`,
    name: path.replace(/\//g, '-'),
    component: () => import(`@/views/${key.replace(/^\.\//, '')}`)
  })
})

// 添加默认路由
routes.push({
  path: '/',
  redirect: '/login'// 重定向到你的首页

})

export default routes